module.exports = __webpack_public_path__ + "static/media/all-activities-un.97527cd7.svg";